import React from "react";
import { Box, Image, AspectRatio } from "@chakra-ui/react";
import shape from "../../assets/images/header-shape.svg";
import logo from "../../assets/images/logo.png";

//#a8ca5c -> cima
//#8ac26f -> baixo

const LogoSide = () => {
  return (
    <Box pos="fixed" zIndex={1} left="calc(50% - min(50vw, 300px))" top={0}>
      <AspectRatio
        w="50vw"
        maxW="300px"
        ratio={34 / 19}
        filter="drop-shadow(3px 2px 7px #00000070)"
      >
        <Image src={shape} alt="Header" />
      </AspectRatio>
      <Box
        pos="absolute"
        top="calc(min(12vw, 72px) / 34 * 19)"
        left="min(4vw, 24px)"
        boxSize="min(27vw, 162px)"
      >
        <Image src={logo} alt="Logo" />
      </Box>
    </Box>
  );
};

export { LogoSide };
